import { Pipe, PipeTransform } from '@angular/core';
import { Usuario } from '../../modelos/usuario';

@Pipe({
  name: 'filtroUsuarios',
  pure: false
})
export class FiltroUsuariosPipe implements PipeTransform {

  transform(usuarios: Usuario[], filtro?: string): any {
    if (usuarios === undefined || filtro === undefined || filtro.trim() === '') {
      return usuarios;
    }
    filtro = filtro.toLocaleLowerCase();
    return usuarios.filter(usuario => usuario.obterNomeUsuario.toLocaleLowerCase().indexOf(filtro) >= 0);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-usuarios.pipe.ts